import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/stores/google-play.svg")